import BlockHelper from "../../helpers/Block/BlockHelper";
import ResizableForm from '../../../../spine-cms-vue/src/components/mixins/ResizableForm.js';

Vue.asyncComponent('bp-settings-form',{
    mixins: [ResizableForm],
    props: {
        dataProvider: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showConfirm: false,
            confirmCallback: null,
            alertUnsaved: null,
            unsavedChangesMessage: false,
            loading: false,
            formData: false,
            blockToEdit: null,
        }
    },
    computed: {
        showForm() {
            return this.blockToEdit?.settings?.hasForm;
        },
        formUrl() {
            return this.dataProvider.getSettingsFormUrl(
                    this.$route.params.blockType,
                    this.$route.query.verticalId,
                    this.$route.params.blueprintId,
                    this.$route.params.hashId,
                    this.$route.query.versionId
            );
        },
        saveFormUrl() {
            return this.dataProvider.getSaveSettingsFormUrl(
                    this.$route.params.blockType,
                    this.$route.query.verticalId,
                    this.$route.params.blueprintId,
                    this.$route.params.hashId,
                    this.$route.query.versionId
            );
        },
        relationString() {
            return this.$route.params.relationString;
        },
        /**
         * Uniquge id for the width in localstorage
         * @return {string}
         */
        localStorageWidthId() {
            return 'editor-settings-width';
        }
    },
    methods: {
        saveSettings($event) {
            this.$emit('saveSettings', {...$event, referenceId: this.$route.params.referenceId});
            this.close();
        },
        saveSettingsAndBlueprint($event) {
            const eventData = {...$event, referenceId: this.$route.params.referenceId};

            this.$emit('saveSettings', eventData);
            // The response's updateName event is handled in the current tick. (for form blueprints)
            // Save after it has updated the block used to build the payload.
            this.$nextTick(() => {
                this.$emit('saveBlueprint');
                this.close();
            });
        },
        updateName($event) {
            this.$emit('blockPropertyChanged', {...$event, referenceId: this.$route.params.referenceId});
        },
        confirmDialog() {
            this.showConfirm = false;
            this.confirmCallback();
        },
        alertUnsavedChanges({showAlert, message}) {
            this.alertUnsaved = showAlert;
            this.unsavedChangesMessage = message;
        },
        attemptClose(close) {
            if (! this.alertUnsaved) {
                close();
                return;
            }

            this.showConfirm = true;
            this.confirmCallback = close;
        },
        close() {
            // go to the parent route
            this.$router.push({
                ...this.$route.matched[0],
                query: this.$route.query
            });
        },
        getBlock(blocks, id) {
            let result = null;

            // get the block by id recursive
            blocks.forEach(block => {
                if(block.id === id) {
                    result = block;
                }

                if(block.blocks.length) {
                    let childResult = this.getBlock(block.blocks, id);
                    if(childResult) {
                        result = childResult;
                    }
                }
            });

            return result;
        },
        /**
         * Get the formData needed for the form
         * @returns {Promise<void>}
         */
        async getFormData() {
            let param = {
                locale: this.$localeHandler.getActiveLocale()
            };
            this.loading = true;

            try {
                const data = {
                    formValues : this.blockToEdit.settings?.values
                };
                this.formData  = await this.$post(this.formUrl, data, param);

                this.loading = false;
            } catch (error) {
                console.log(error);
            }
        }
    },
    created() {
        this.blockToEdit = BlockHelper.getBlock(this.dataProvider.getBlocks(), this.$route.params.referenceId);

        if (this.showForm) {
            this.getFormData();
        }
    }
}, 'blueprints/form/bp-settings-form.html');
